import { Icon } from "@iconify/react";
import { Input } from "@/shared/components/dialog";
import { Select } from "@/shared/components/select";
import { cn } from "@/shared/lib/utils";
import { RequiredMark } from "@/shared/components/RequiredMark";

interface IconTextFieldProps {
  icon: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "email";
  required?: boolean;
  className?: string;
}

export function IconTextField({ icon, label, value, onChange, placeholder, type = "text", required, className }: IconTextFieldProps) {
  return (
    <div className={className}>
      <label className="mb-1.5 block text-xs font-semibold text-[#374151]">
        {label}
        {required && <RequiredMark />}
      </label>
      <div className="msq-field-shell flex h-[42px] items-center gap-2.5 rounded-xl border border-[#E5E7EB] bg-[#F9FAFB] px-3 [&_:focus-visible]:!outline-none">
        <Icon icon={icon} className="h-4 w-4 shrink-0 text-[#9CA3AF]" />
        <span className="h-4 w-px shrink-0 bg-[#E5E7EB]" />
        <Input
          variant="borderless"
          type={type}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          required={required}
          className={cn("!h-full !w-full !bg-transparent !p-0 !text-sm !text-[#0A2947] placeholder:!text-[#9CA3AF]")}
        />
      </div>
    </div>
  );
}

interface IconSelectFieldProps {
  icon: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  className?: string;
}

export function IconSelectField({ icon, label, value, onChange, options, className }: IconSelectFieldProps) {
  return (
    <div className={className}>
      <label className="mb-1.5 block text-xs font-semibold text-[#374151]">{label}</label>
      <div className="msq-field-shell flex h-[42px] items-center gap-2.5 rounded-xl border border-[#E5E7EB] bg-[#F9FAFB] px-3 [&_:focus-visible]:!outline-none">
        <Icon icon={icon} className="h-4 w-4 shrink-0 text-[#9CA3AF]" />
        <span className="h-4 w-px shrink-0 bg-[#E5E7EB]" />
        <Select
          variant="borderless"
          value={value}
          onChange={(next) => onChange(next)}
          options={options.map((option) => ({ value: option, label: option }))}
          suffixIcon={<Icon icon="lucide:chevron-down" className="h-4 w-4 shrink-0 text-[#9CA3AF]" />}
          className="!h-full !w-full !text-sm !text-[#0A2947]"
          popupMatchSelectWidth
        />
      </div>
    </div>
  );
}
